import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const ContentModal = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  width: 600px;
  height: fit-content;
  max-width: 70%;
  background: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  overflow: auto;
  transform: translate(-50%, -50%);
  .MuiTypography-body1 {
    font-size: 14px;
  }
`;

export const ButtonConfirm = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.neutral.white};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover:not(:disabled) {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.medium};
    transform: translateY(-1px);
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
export const ButtonCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  border: 1px solid;
  color: ${({ theme }) => theme.button.primaryBorder};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.medium};
    transform: translateY(-1px);
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  height: auto;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[950]};
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.border.purpleLight};
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  border-radius: 9px;
  margin-top: 1em;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.text.secondary};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.neutral.gray[1300]};
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
    };
  },
};

export const IconGuest = styled.img`
  width: 18.33px;
`;

export const useStyles = makeStyles(() => ({
  checkboxStyle: {
    color: theme.primary.purple,
    width: "0.5em",
  },
}));
